export default "__VITE_ASSET__BYDjPSEm__"